import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { pretty } from '@eastcoal/common/utils/decimal'
import { pick } from '@eastcoal/common/utils/object'

import { BizType } from '@eastcoal/shared/enums/BizType'

import { TradeSessionStatus } from '../../../../../../enums/TradeSessionStatus'
import { useAuctionDetailStore } from '../../../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  card: {
    paddingInline: token.paddingXS,
    backgroundColor: token.colorWhite,
    borderRadius: token.borderRadiusXS
  },
  title: {
    padding: token.paddingXS,
    borderBlockEnd: `1px solid ${token.colorBorderSecondary}`
  },
  note: {
    color: token.colorTextTertiary,
    fontSize: token.fontSizeSM
  },
  content: {
    display: 'flex',
    padding: token.paddingXS,
    gap: token.paddingXS,
    flexWrap: 'wrap'
  },
  column: {
    minWidth: '20%'
  },
  label: {
    color: token.colorTextLabel
  },
  value: {
    fontWeight: token.fontWeightStrong
  }
}))

const isHiddenValue = (onceBid: boolean, value?: number) =>
  onceBid && isNil(value)

export const AuctionDetailTipCard = () => {
  const { theme, styles } = useStyles()

  const {
    bidTip = {},
    detailData = {},
    statusInfo,
    isBidOnlyOnce
  } = useAuctionDetailStore(state =>
    pick(state, ['bidTip', 'detailData', 'statusInfo', 'isBidOnlyOnce'])
  )
  const onceBid = isBidOnlyOnce()
  const { allowMinPrice, maxPrice, myPrice, myDealCount, myRank } = bidTip
  const bidUnstarted = (statusInfo?.status ?? 0) < TradeSessionStatus.BIDDING

  const items = [
    {
      label: '当前最高出价：',
      value: isHiddenValue(onceBid, maxPrice)
        ? '***'
        : (pretty(maxPrice) ?? '无'),
      color: theme.red
    },
    {
      label: '最低可成交价：',
      value:
        isHiddenValue(onceBid, allowMinPrice) || bidUnstarted
          ? '***'
          : (pretty(allowMinPrice) ?? '无'),
      color: theme.green
    },
    {
      label: '您的当前价：',
      value: isHiddenValue(onceBid, myPrice)
        ? '***'
        : (pretty(myPrice) ?? '无'),
      color: theme.blue
    },
    {
      label: '待成交份数：',
      value: isHiddenValue(onceBid, maxPrice) ? '***' : (myDealCount ?? '无'),
      color: theme.blue,
      visible:
        // 竞拍（排名）类型的整体拍不展示该字段
        !(
          detailData.bizType === BizType.RANKING_AUCTION && detailData.wholeSale
        )
    },
    {
      label: '出价排名：',
      value: myRank ?? '无',
      color: theme.blue,
      visible:
        // 只有竞拍（排名）类型的整体拍展示该字段
        detailData.bizType === BizType.RANKING_AUCTION && detailData.wholeSale
    }
  ]

  return (
    <div className={styles.card}>
      <div className={styles.title}>
        <span>出价建议</span>
        <span className={styles.note}>（建议仅供参考，不对竞价结果负责）</span>
      </div>
      <div className={styles.content}>
        {items.map(({ label, value, color, visible = true }) =>
          visible ? (
            <div key={label} className={styles.column}>
              <span className={styles.label}>{label}</span>
              <span
                className={styles.value}
                style={{
                  color
                }}
              >
                {value}
              </span>
            </div>
          ) : null
        )}
      </div>
    </div>
  )
}
